let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kNFvF"), load("94Pxn")]).then(() => parcelRequire('68kUi'));